export function convertSecondsToReadableTime(
  totalSeconds: number,
  isArabic = false
): string {
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const d = isArabic ? "يوم" : "d";
  const h = isArabic ? "س" : "h";
  const m = isArabic ? "د" : "m";
  const s = isArabic ? "ث" : "s";

  const parts: string[] = [];

  if (days > 0) parts.push(`${days}${d}`);
  if (hours > 0) parts.push(`${hours}${h}`);
  if (minutes > 0) parts.push(`${minutes}${m}`);
  if (seconds > 0 || parts.length === 0) parts.push(`${seconds}${s}`);

  return parts.join(" ");
}
